import { UserAccessRequestResultValue } from '../../../../graphql/API';

export enum TabOption {
  accepted = UserAccessRequestResultValue.accepted,
  rejected = UserAccessRequestResultValue.declined,
  blocked = 'blocked',
}
